import React, { useState, useRef } from "react";
import { useStores } from "../../../store";
import { useObserver } from "mobx-react";
import { apiPostPut } from "../../../api/api_methods";
import { uploadFileToAzure } from "../../../services/azure";
import Popup from "../../reusble_components/popup";
import { loginWarningImage } from "../../../helpers/constantVariables";
import { useNavigate } from "react-router-dom";
import { setDataToLocalStorage } from "../../../services/localStorage";
// import { AiOutlineCheckCircle } from "react-icons/ai";
import {
  AiFillWarning,
  AiOutlineCheckCircle,
  AiOutlineIssuesClose,
} from "react-icons/ai";

const TechnicalInterviewOverview = ({
  showApply,
  interviewType,
  interviewLevel,
  numberOfQuestions,
  noOfFollowUps,
  // cutoff,
  customQuestions,
  forJobPost,
  onEdit,
  cutoff,
  // userId,
  jobPostId,
  // showEditButton
}) => {
  const { UserStore, RecuiterStore } = useStores();
  // const [showApply, setShowApply] = useState(false); // This should be managed according to your application logic
  const [resume, setResume] = useState(null);
  const [selectedResume, setselectedResume] = useState(null);
  const [showResumeCard, setShowResumeCard] = useState(false);
  const fileInputRef = useRef(null);
  const [loading, setloading] = useState(false);

  const [showLoginWarning, setshowLoginWarning] = useState(false);
  const handleApplyForJob = async () => {
    if (localStorage.getItem("user") === null) {
      return setshowLoginWarning(true);
    }

    if (!resume) {
      setShowResumeCard(true);
      return alert("Please upload your resume to apply job");
    }

    const userDetails = JSON.parse(localStorage.getItem("user"));
    const userId = userDetails?._id;
    const data = {
      userId: userId,
      jobPostId: jobPostId,
      resume: resume,
    };
    console.log(data);
    try {
      setloading(true);
      const apiResponse = await apiPostPut(
        data,
        "/application/new-application",
        "POST"
      );
      setloading(false);
      if (apiResponse.status === 200) {
        alert("Application submitted successfully");
      } else {
        alert(apiResponse?.body?.message);
      }
    } catch (error) {
      alert("Failed to submit application");
      console.error("Error submitting application:", error);
    } finally {
      // setApplying(false);
    }
  };
  const handleFileChange = async (e) => {
    try {
      const timestamp = Date.now().toString();
      const min = 1000;
      const max = 9999;
      const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
      const filename = randomNumber + timestamp;
      setselectedResume(e.target.files[0]);
      setloading(true);
      const fileUploaded = await uploadFileToAzure(
        filename,
        e.target.files[0],
        { action: "resume" }
      );
      setloading(false);

      const stringifiedURL = JSON.stringify(fileUploaded.url);
      localStorage.setItem("resume", stringifiedURL);
      setResume(fileUploaded.url);
      // setApplying(true);

      console.log(fileUploaded.url);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const navigate = useNavigate();

  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  return useObserver(() => (
    <div className="container mx-auto gil-reg">
      <Popup
        popUpInitialValue={showLoginWarning}
        handlePopup={() => {
          setshowLoginWarning(false);
        }}
        image={loginWarningImage}
        content="Please signup to apply for job"
        buttontext="Signup now"
        onClick={() => {
          redirectToSignupPageWithCurrentUrl();
          setshowLoginWarning(false);
        }}
      />

      {!numberOfQuestions ? (
        <div className="w-full md:mx-8 mx-4 mt-5 flex flex-col items-start space-y-4">
          {/* Header Section */}
          {/* <div className="flex items-center space-x-2">
            <AiOutlineIssuesClose className="text-red-500 text-3xl" />
            <span className="text-red-500 font-bold text-lg ">
              Technical Interview not added
            </span>
          </div> */}
        </div>
      ) : (
        <div className="  border-primary border-t-0">
          <div className="flex flex-row sm:flex-row justify-between items-start sm:items-center mb-4">
            {/* <button
            onClick={onEdit}
            className={`text-primary text-sm flex flex-row hover:underline md:-mt-10 lg:-mt-12  ${
              JSON.parse(localStorage.getItem("user"))?.role?.role === "company"
                ? "block"
                : "hidden"
            }`}>
            Edit details <RiEditLine className="mt-1 ml-1" />
          </button> */}
          </div>
          {isNaN(numberOfQuestions) || !numberOfQuestions ? (
        <div className="w-full md:mx-8 mx-4  mt-5 flex flex-col items-start space-y-4">
          {/* Header Section */}
          <div className="flex items-center space-x-2">
            <AiOutlineIssuesClose className="text-red-500 text-3xl" />
            <span className="text-red-500 font-bold text-lg ">Technical interview</span>
          </div>

          {/* Warning Message Section */}
          <div className="flex items-center space-x-2">
            <AiFillWarning className="text-yellow text-2xl" />
            <span className="text-yellow text-sm font-semibold">
              You skipped this section
            </span>
          </div>

          {/* Divider */}
        </div>
          )
          
           : (
            <div className="md:mx-8 mx-4 mt-5 ">
              <div className="flex items-center space-x-2 mb-4 ">
                <AiOutlineCheckCircle className="text-green-500 text-3xl" />
                <span className="text-green-500 font-bold text-lg  ">
                  Technical interview
                </span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4 text-gray-800">
                <div className="flex items-center">
                  <span className="pl-2">
                    {forJobPost ? "Type of interview" : "Technology"}:{" "}
                    <span className="font-bold">
                      {numberOfQuestions !== null ? interviewType : "Not added"}
                    </span>
                  </span>
                </div>
                <div className="flex items-center">
                  <span className=" pl-2">
                    Number of questions:{" "}
                    <span className="font-bold">
                      {numberOfQuestions ? numberOfQuestions : "Not added"}
                    </span>
                  </span>
                </div>
                <div className="flex items-center">
                  <span className=" pl-2">
                    Number of followups:{" "}
                    <span className="font-bold">
                      {noOfFollowUps ? noOfFollowUps : "Not added"}
                    </span>
                  </span>
                </div>
                {interviewType === "AI interview" && (
                  <div className="flex items-center">
                    <span className=" pl-2">
                      Level of interview:{" "}
                      <span className="font-bold">{interviewLevel}</span>
                    </span>
                  </div>
                )}
                <div className="flex items-center">
                  <span className=" pl-2">
                    CutOff:{" "}
                    <span className="font-bold">
                      {!cutoff || cutoff === "undefined" || cutoff === ""
                        ? "Not Mentioned"
                        : cutoff + "%"}
                    </span>
                  </span>
                </div>

                {/* {forJobPost &&
              (customQuestions === "Not added" ||
              customQuestions.length === 0 ? (
                <div className="flex items-center">
                  <span className="  pl-2">
                    Custom Questions:{" "}
                    <span className="font-bold">Not added</span>
                  </span>
                </div>
              ) : (
                <div>
                  <h4 className=" mb-2 ">Custom Questions :</h4>
                  <ul className="list-decimal list-inside font-bold">
                    {customQuestions.map((question, index) => (
                      <li key={index}>{question}</li>
                    ))}
                  </ul>
                </div>
              ))} */}
              </div>
            </div>
          )}

          {/* {showApply && (
          <div className="flex w-full flex-col justify-center items-center mt-[5%]">
            <input
              type="file"
              accept=".pdf, .doc, .docx"
              className="hidden"
              ref={fileInputRef}
              multiple={false}
              onChange={handleFileChange}
            />

            {showResumeCard && (
              <div className="max-w-sm mx-auto bg-white shadow-md rounded-lg overflow-hidden mb-4">
                <div className="p-6">
                  <h2 className="text-lg font-semibold text-gray-700">
                    Upload Your Resume
                  </h2>
                  <div className="mt-4 flex justify-center items-center">
                    <input
                      type="file"
                      accept=".pdf, .doc, .docx"
                      className="hidden"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                    <button
                      onClick={() => fileInputRef.current.click()}
                      className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary focus:outline-none flex items-center justify-center"
                    >
                      {loading ? (
                        <svg
                          className="animate-spin h-5 w-5 mr-3"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                          ></path>
                        </svg>
                      ) : (
                        "Choose File"
                      )}
                    </button>
                  </div>
                  {resume && (
                    <div className="mt-4 text-center text-gray-700">
                      <p>
                        Selected File:{" "}
                        <span className="font-bold">
                          {selectedResume?.name}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}

            <button
              onClick={handleApplyForJob}
              className="bg-primary text-white p-3 rounded-md"
              disabled={loading}
            >
              {loading ? (
                <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
              ) : (
                "Apply for Job"
              )}
            </button>

            <div>
              <div className="flex flex-row justify-center text-sm md:text-base text-[#EDAD07] mt-5">
                <GoAlertFill className="-mt-2 h-8 w-8" />
                <p>
                  Make sure that you complete the interview process(all above
                  mentioned fields) within 24 hours of applying for the job.
                </p>
              </div>
            </div>
          </div>
        )} */}
        </div>
      )}
    </div>
  ));
};

export default TechnicalInterviewOverview;
